import { Button, Input, Radio } from 'antd';
import { ComponentLacunasService } from 'core/http/service/componetInteraction/ComponentLacunasService.service';
import Colors from 'enums/Colors';
import { isArray } from 'lodash';
import ComponentInteractionModel from 'models/componentInteraction/ComponentInteraction';
import ComponentLacunas from 'models/componentInteraction/ComponentLacunas';
import ComponentLacunasAlternativas from 'models/componentInteraction/ComponentLacunasAlternativas';
import editorConfig from 'pages/diarioBordo/components/textEditor/editorConfig';
import React, { useEffect, useState } from 'react';
import { MdAdd, MdDeleteForever } from 'react-icons/md';
import ReactQuill from 'react-quill';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        max-width: 50%;
    `,

    Row: styled.div`
        display: flex;
        gap: 1rem;
    `,

    Column: styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    `,

    Title: styled.h1`
        color: ${Colors.Blue};
        font-size: 18px;
        font-weight: 600;
    `,

    Alternativa: styled.div`
        display: flex;
        align-items: center;
        width: fit-content;
    `,
};

interface IComponentLacunasAdmin {
    dados: ComponentInteractionModel;
    handleAttComponent: (value: any) => void;
}

const serviceLacuna = new ComponentLacunasService();

const ComponentLacunasAdmin: React.FC<IComponentLacunasAdmin> = ({ dados, handleAttComponent }) => {
    const [component, setComponent] = useState<ComponentInteractionModel | null>(null);
    const [qtdLacunas, setQtdLacunas] = useState<number>(0);
    const [addLacunaText, setLacunaText] = useState<number>(0);

    const getLacunas = (): ComponentLacunas | null => {
        const componentInteraction = component;

        if (componentInteraction) {
            const lacunas = componentInteraction.lacunas as ComponentLacunas;

            return lacunas;
        }

        return null;
    };

    const handleTexts = (value: string, textAux: boolean) => {
        let lacunas = getLacunas();
        if (lacunas) {
            if (textAux) {
                lacunas.textAux = value;
            } else {
                lacunas.text = value;
            }
        }

        handleAttComponent({ ...component, lacunas: lacunas });
    };

    const addNewOption = () => {
        const componentInteraction = component;

        if (componentInteraction) {
            const lacunas = componentInteraction.lacunas;

            if (lacunas) {
                const novaAlternativa = new ComponentLacunasAlternativas().fromJSON({
                    codigo: -1,
                    correct: false,
                    alternativa: JSON.stringify(Array.from({ length: qtdLacunas }).map(() => '')),
                });

                const alternativas = isArray(lacunas.alternativas) ? [...lacunas.alternativas, novaAlternativa] : [novaAlternativa];

                const lacunasAtt = new ComponentLacunas().fromJSON({
                    ...lacunas,
                    alternativas: alternativas,
                });

                handleAttComponent({ ...component, lacunas: lacunasAtt });
            }
        }
    };

    const addLacunas = () => {
        const componentInteraction = component;

        if (componentInteraction) {
            const lacunas = componentInteraction.lacunas;

            if (lacunas) {
                // Incrementa a quantidade de lacunas
                const qtdLacunas = lacunas.qtdLacunas + 1;

                // Atualiza as alternativas com o novo número de lacunas
                const alternativasAtualizadas = lacunas.alternativas.map(alt => {
                    const array = JSON.parse(alt.alternativa || '[]');

                    while (array.length < qtdLacunas) {
                        array.push('');
                    }

                    return {
                        ...alt,
                        alternativa: JSON.stringify(array),
                    };
                });

                // Atualiza o componente com os novos dados
                handleAttComponent({
                    ...component,
                    lacunas: {
                        ...lacunas,
                        qtdLacunas,
                        alternativas: alternativasAtualizadas,
                    },
                });

                setLacunaText(1);
            }
        }
    };

    const removeLacunas = () => {
        const componentInteraction = component;

        if (componentInteraction) {
            let lacunas = componentInteraction.lacunas;

            if (lacunas) {
                let qtdLacunas = lacunas.qtdLacunas;
                qtdLacunas--;

                const alternativasAtualizadas = lacunas.alternativas.map(alt => {
                    let array = JSON.parse(alt.alternativa || '[]');

                    array.splice(array.length - 1, 1);

                    return {
                        ...alt,
                        alternativa: JSON.stringify(array),
                    };
                });

                // Atualiza lacunas com alternativas modificadas
                handleAttComponent({
                    ...component,
                    lacunas: {
                        ...lacunas,
                        qtdLacunas,
                        alternativas: alternativasAtualizadas,
                    },
                });

                setLacunaText(2);
            }
        }
    };

    const updateStringAlt = (value: string, indexAlt: number, indexValue: number) => {
        let lacunas = getLacunas();
        if (lacunas) {
            // Cria uma nova lista de alternativas atualizada
            const alternativasAtualizadas = lacunas.alternativas.map((alt, i) => {
                if (i === indexAlt) {
                    try {
                        const array = JSON.parse(alt.alternativa || '[]'); // parse apenas da string interna
                        array[indexValue] = value; // modifica o valor
                        return {
                            ...alt,
                            alternativa: JSON.stringify(array), // salva de volta como string
                        };
                    } catch (e) {
                        console.error('Erro ao fazer parse de altString:', alt.alternativa, e);
                        return alt;
                    }
                }
                return alt;
            });

            // Atualiza o objeto lacunas com as alternativas modificadas
            lacunas.alternativas = alternativasAtualizadas as ComponentLacunasAlternativas[];

            // Aqui você pode fazer algo como setLacunas(lacunas) se estiver usando useState, etc.
            handleAttComponent({ ...component, lacunas: lacunas });
        }
    };

    const updateAltCorrect = (indexAlt: number) => {
        let lacunas = getLacunas();
        if (lacunas) {
            lacunas.alternativas.map((alt, i) => {
                if (i === indexAlt) {
                    try {
                        alt.correct = true;
                        return {
                            ...alt,
                        };
                    } catch (e) {
                        return alt;
                    }
                } else {
                    alt.correct = false;
                }
                return alt;
            });

            handleAttComponent({ ...component, lacunas: lacunas });
        }
    };

    const handleRemoveAlternativa = async (indexAlt: number) => {
        const alternativa = component?.lacunas?.alternativas[indexAlt] ?? null;

        if (alternativa && alternativa.codigo != null && alternativa.codigo != -1) {
            await serviceLacuna.deleteById(alternativa.codigo);
        }

        const alternativasAtualizadas = component?.lacunas?.alternativas.splice(indexAlt, 1);

        handleAttComponent({
            ...component,
            lacunas: {
                ...component?.lacunas,
                alternativa: alternativasAtualizadas,
            },
        });
    };

    useEffect(() => {
        if (dados && addLacunaText === 1) {
            setLacunaText(0);
            handleTexts(dados.lacunas?.text + '_______', false);
        }
    }, [addLacunaText, dados]);

    useEffect(() => {
        if (dados) {
            setComponent(dados);
            setQtdLacunas(dados.lacunas?.qtdLacunas ?? 0);
        }
    }, [dados]);

    return (
        <Styled.Container>
            <Styled.Title>Lacuna</Styled.Title>
            <Styled.Row>
                <ReactQuill
                    placeholder="Digite o título"
                    theme="snow"
                    style={{ backgroundColor: '#F5F5F5', width: '100%' }}
                    modules={editorConfig.modules2}
                    formats={editorConfig.formats2}
                    value={component?.lacunas?.text ?? ''}
                    onChange={val => handleTexts(val, false)}
                />

                <Styled.Column>
                    <h1 style={{ fontSize: 32, fontWeight: 700 }}>{qtdLacunas ?? 0}</h1>
                    <Button
                        size="large"
                        style={{ backgroundColor: Colors.Blue, color: Colors.White, width: 210 }}
                        onClick={() => {
                            addLacunas();
                        }}
                    >
                        Inserir Lacuna
                    </Button>
                    <Button size="large" style={{ backgroundColor: Colors.DeleteRed, color: Colors.White }} onClick={removeLacunas}>
                        Remover a última Lacuna
                    </Button>
                </Styled.Column>
            </Styled.Row>
            <Input
                size="large"
                placeholder="Texto auxiliar"
                style={{ maxWidth: '84%' }}
                value={component?.lacunas?.textAux ?? ''}
                showCount
                maxLength={200}
                onChange={e => handleTexts(e.target.value, true)}
            />

            {component?.lacunas &&
                isArray(component.lacunas.alternativas) &&
                component.lacunas.alternativas.map((alt: ComponentLacunasAlternativas, index: number) => {
                    const listAlt =
                        alt.alternativa != null && alt.alternativa.trim().length > 0
                            ? JSON.parse(alt.alternativa)
                            : Array.from({ length: qtdLacunas }).map((_, i) => '');

                    return (
                        <Styled.Row style={{ gap: 0, paddingLeft: '22px', alignItems: 'center' }} key={index}>
                            <Radio name="lacunas" checked={alt.correct} onClick={() => updateAltCorrect(index)} />
                            {listAlt.map((value: string, indexLacunas: number) => (
                                <Styled.Alternativa key={indexLacunas}>
                                    <div style={{ width: '20px', border: '1px solid gray', display: indexLacunas === 0 ? 'none' : '' }} />
                                    <Input
                                        size="large"
                                        placeholder="Texto"
                                        value={value}
                                        onChange={e => updateStringAlt(e.target.value, index, indexLacunas)}
                                        style={{ width: '200px' }}
                                        showCount
                                        maxLength={30}
                                    />
                                </Styled.Alternativa>
                            ))}
                            <MdDeleteForever
                                size={26}
                                color={Colors.DeleteRed}
                                cursor={'pointer'}
                                onClick={() => handleRemoveAlternativa(index)}
                            />
                        </Styled.Row>
                    );
                })}

            <Button size="large" style={{ maxWidth: 200 }} onClick={addNewOption} icon={<MdAdd />}>
                Adicionar nova opção
            </Button>
        </Styled.Container>
    );
};

export default ComponentLacunasAdmin;
